import Icon from './Icon';

/**
 * Metric tile: uppercase label, large figure, optional trend chip and footer row.
 * `trend` is a number in percent; positive renders green, negative red.
 */
export default function KpiCard({ label, value, icon, trend, suffix, footer, iconClassName = '' }) {
  const hasTrend = typeof trend === 'number';
  const up = hasTrend && trend >= 0;

  return (
    <div className="bg-surface-container-lowest rounded-xl p-5 border border-outline-variant/30 shadow-xs hover:shadow-sm transition-shadow flex flex-col justify-between gap-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <span className="text-[11px] font-semibold text-on-surface-variant uppercase tracking-wider block">
            {label}
          </span>
          <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1 mt-1.5">
            <span className="text-3xl font-bold text-on-surface tracking-tight tabular">{value}</span>
            {hasTrend && (
              <span
                className={`inline-flex items-center gap-0.5 text-xs font-semibold px-2 py-0.5 rounded ${
                  up ? 'text-secondary bg-primary-fixed/50' : 'text-error bg-error-container/60'
                }`}
              >
                <Icon name={up ? 'trending_up' : 'trending_down'} size={14} />
                {up ? '+' : ''}
                {trend}%
              </span>
            )}
            {suffix && <span className="text-xs font-medium text-on-surface-variant">{suffix}</span>}
          </div>
        </div>
        {icon && (
          <div
            className={`w-10 h-10 rounded-lg bg-surface-container-low flex items-center justify-center text-primary-container shrink-0 ${iconClassName}`}
          >
            <Icon name={icon} size={22} />
          </div>
        )}
      </div>
      {footer && (
        <div className="flex items-center justify-between gap-3 text-xs text-on-surface-variant pt-2 border-t border-surface-container">
          {footer}
        </div>
      )}
    </div>
  );
}
